import StorageManager from '@/services/sessionStorageManager';

export default {
  methods: {
    /** Salva o filtro no storage e redireciona para tela de relatório
     * de alarmes com o id do filtro salvo na rota
     * @param filter.companiesIds ids das empresas
     * @param filter.regionalIds ids das regionais
     * @param filter.installationsIds ids das instalações
     * @param filter.assetsIds ids dos ativos
     * @param filter.alarmStatus status dos alarmes
     * @param filter.classifications classificações dos alarmes
     * @param filter.installationStatus status das instalações
     * @param filter.period periodo filtrado (Não utilizado se utilizar periodo final e inicial)
     * @param filter.finalDate periodo final
     * @param filter.initialDate periodo inicial
    */
    openAlarmReport(filter) {
      this.saveOnCacheAndOpenNewWindow(filter,
        'alarmsHistoryFilter',
        'clean-view.alarms-and-warnings.view-report');
    },
    /** Salva o filtro no storage e redireciona para tela
     * de alarmes e avisos com o id do filtro salvo na rota
     * @param filter.companiesIds ids das empresas
     * @param filter.regionalIds ids das regionais
     * @param filter.installationsIds ids das instalações
     * @param filter.assetsIds ids dos ativos
     * @param filter.alarmsIds ids dos alarmes
     * @param filter.status status dos alarmes
     * @param filter.classifications classificações dos alarmes
     * @param filter.installationStatus status das instalações
     * @param filter.period periodo filtrado
     */
    openAlarmAndWarning(filter) {
      this.saveOnCacheAndOpenNewWindow(filter,
        'alarmAndWarningFilter',
        'alarms-and-warnings');
    },
    /*
      @deprecated Não utilizar fora do mixin
     */
    saveOnCacheAndOpenNewWindow(filter, storageName, route) {
      const redirectedFilter = { ...filter, redirected: true };
      const stringifyFilter = JSON.stringify(redirectedFilter);
      const storageKey = StorageManager.setItemWithId(storageName, stringifyFilter);
      const routeData = this.$router.resolve({
        name: route,
        query: {
          filter: storageKey,
        },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
